<ng-container *ngIf="(activeStream$ | async) === null">
  <ng-container *ngIf="items?.length">
    <div class="stage-section-wrapper" [class.container-sm]="items.length > 1">
      <ng-container *ngIf="items.length === 1; else sliderTpl">
        <ng-container *ngTemplateOutlet="itemSwitchTpl; context: { item: items[0], active: true }"></ng-container>
      </ng-container>

      <div class="stage-section-footer" *ngIf="hasBottomSpace && activeStageItem">
        <a
          class="btn btn-quaternary"
          [href]="activeStageItem.icsLink"
          [class.d-none]="!activeStageItem.showIcsDownload"
        >
          <span class="mb-icon mb-icon-calendar-date"></span>
          <span>{{ 'ICS_DOWNLOAD_LABEL' | translate }}</span>
        </a>
        <button
          class="btn btn-quaternary"
          (click)="openEmbedOverlay(activeStageItem.id)"
          [class.d-none]="!activeStageItem.showEmbedCode"
        >
          <span class="mb-icon mb-icon-chain"></span>
          <span>{{ activeStageItem.embedText || ('EMBED_VIDEO' | translate) }}</span>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #sliderTpl>
    <div class="row">
      <mb-item-slider
        [items]="items"
        [itemTpl]="customTpl"
        (indexChanged)="setSlideIndex($event)"
        [initialIndex]="slideIndex"
        class="col-sm-8 offset-sm-2 col-md-10 offset-md-1"
      ></mb-item-slider>
    </div>
    <ng-template #customTpl let-item="item" let-active="active">
      <ng-container *ngTemplateOutlet="itemSwitchTpl; context: { item: item, active: active }"></ng-container>
    </ng-template>
  </ng-template>

  <ng-template #itemSwitchTpl let-item="item" let-active="active">
    <ng-container [ngSwitch]="item.media?.mediaType">
      <ng-container *ngSwitchCase="mediaType.STREAM">
        <ng-container *ngTemplateOutlet="streamTpl; context: { item: item.media, active: active }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="imageTpl; context: { item: item, active: active }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #imageTpl let-item="item" let-active="active">
    <mb-stage-item
      [class.active-item]="active"
      [topline]="item.topline"
      [title]="item.title"
      [subtitle]="item.subtitle"
      [fuelLabel]="item.fuelLabel"
      [media]="item.media"
    ></mb-stage-item>
  </ng-template>

  <ng-template #streamTpl let-item="item" let-active="active">
    <mb-stream-card
      [class.active-item]="active"
      [countdownType]="items.length > 1 ? countdownTypes.FLAT : countdownTypes.ROUND"
      [stream]="item"
    ></mb-stream-card>
  </ng-template>
</ng-container>
